
export const getGrantsForUser = state => state.grants.get('grantsForUser')
export const getGrantPermissions = state => state.grants.get('grantPermissions')
export const checkGrantIsLoading = (state, key) => state.grants.get('checkGrantLoading')[key]
export const isCheckGrantsLoading = (state, key) => !!state.grants.get('checkGrantsLoading')[key]
export const isCreateGrantLoading = state => !!state.grants.get('createGrantLoading')
export const isGetGrantsForActiveUserLoading = state => !!state.grants.get('getGrantsForActiveUserIsLoading')
export const getLastTimeGrantsChecked = (state, key) => state.grants.get('lastTimeGrantsChecked')[key]
